/* Iceman 2026 系列頁・日本站：顏色／款式／寬度／只看有貨／排序、看更多、重ね付けのおすすめ、組合橫幅、快速選購＋加入購物車
   跟台灣版同一套邏輯；日本：公分在前、日圓、售完＝去商品頁申請再入荷のお知らせ */
(function () {
  var LEN = {
    '16': { t: '40cm（16"）・首元', d: '首元にフィットする短めの長さ。細身のチェーンなら1本ですっきり、重ね付けでは一番内側に。' },
    '18': { t: '45cm（18"）・鎖骨の少し下', d: '鎖骨の少し下に落ちる、すっきりとした長さ。1本使いに最適です。' },
    '20': { t: '50cm（20"）・胸元の上', d: '胸元の上に落ち、クルーネックのTシャツからちょうどのぞく長さ。迷ったらこの長さがおすすめです。' },
    '22': { t: '55cm（22"）・胸の中央の少し上', d: '重ね付けの外側に。45cm・50cmと合わせると、レイヤードに奥行きが出ます。' },
    '24': { t: '60cm（24"）・胸の中央', d: '胸元まで下がる、ストリート感が一番強い長さ。ゆったりしたトップスや、前を開けたシャツに。' }
  };
  var CM = { '16': 40, '18': 45, '20': 50, '22': 55, '24': 60 };
  var IN = { '6': 15.2, '6.5': 16.5, '7': 17.8, '7.5': 19, '8': 20.3, '8.5': 21.6 };
  var FIT = { '6': '14〜15cm', '6.5': '15.5〜16cm', '7': '16.5〜17cm', '7.5': '17.5〜18.5cm', '8': '19〜19.5cm', '8.5': '20.5〜21cm' };
  var STY = {
    n: [['all', 'すべて'], ['plain', 'PLAIN キューバン'], ['rope', 'THE ROPE ロープ'], ['tennis', 'ICE SPARKLER テニス'], ['iced', 'ICEMAN・ICE PRONG']],
    e: [['all', 'すべて'], ['hoop', 'HOOP'], ['moissanite', 'モアサナイト'], ['other', 'その他']],
    mix: [['all', 'すべて'], ['n', 'ネックレス'], ['b', 'ブレスレット'], ['e', 'ピアス'], ['s', 'セット']]
  };
  STY.b = STY.n; STY.s = STY.n;
  var COLORS = [['all', 'すべて', ''], ['w', 'White Gold', 'linear-gradient(135deg,#ffffff,#c4c7cc)'], ['g', '18K Gold', 'linear-gradient(135deg,#f6dc95,#b8862b)']];
  var WIDTHS = [['all', 'すべて', ''], ['thin', '細め', '3–4mm'], ['mid', '標準', '5–6mm'], ['thick', '太め', '8mm以上']];
  var SORTS = [['rec', 'おすすめ順'], ['asc', '価格の安い順'], ['desc', '価格の高い順']];

  function money(c) { return '¥' + Math.round(c / 100).toLocaleString('ja-JP'); }
  // 只寫公分：項鍊 45cm、手鍊 17.8cm
  function cmLab(k) { return CM[k] ? CM[k] + 'cm' : IN[k] ? IN[k] + 'cm' : k + '"'; }
  function keyOf(v) { return v ? String(v).split('（')[0].replace(/["“”]/g, '').trim() : ''; }
  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function wcat(w) { return w <= 4 ? 'thin' : w <= 6 ? 'mid' : 'thick'; }
  var desk = window.matchMedia('(min-width: 990px)');

  // ---------- 快速選購（系列頁、首頁共用）
  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }
  function img(url, w) {
    if (!url) return '';
    url = typeof url === 'string' ? url : url.src || url.url || '';
    url = url.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '?') + 'width=' + w;
  }

  function Quick(root) {
    var wrap = $(root, '[data-qsheet]'); if (!wrap) return null;
    var toastEl = $(root, '[data-toast2]'), toastTimer, lastFocus;
    var Q = { p: null, info: null, kind: '', sel: {}, guide: false, tryImg: '', opt: {} };
    // 從側滑／購物車頁開（老闆 10/15）：opt.photos 上面放照片、opt.guide 尺寸指南先打開、
    // opt.disc＝一起買各尺寸折多少（variant id → 分，2点目割引）、opt.pick＝「フルセットで着用」卡（選尺寸直接セットにする）
    function discOf(m, k) { var d = Q.opt.disc; return d && m[k] ? d[m[k][2]] || 0 : 0; }
    function pickOf(k) { return Q.opt.pick && k ? Q.opt.pick.info(k) : null; }

    function close() {                                   // 側滑購物車裡開的視窗：側滑還開著就不要放開捲動
      wrap.hidden = true;
      if (!document.querySelector('[data-icm-dw].is-open')) document.documentElement.classList.remove('icm-lock');
      if (lastFocus) lastFocus.focus();
    }
    $$(wrap, '[data-close-q]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !wrap.hidden) close(); });

    function toast(text, cart) {
      clearTimeout(toastTimer);
      $(toastEl, '[data-toast2-text]').textContent = text;
      $(toastEl, '[data-toast2-cart]').hidden = !cart;
      toastEl.hidden = false;
      toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2600);
    }

    function combos() {
      // key → [price, available, id, compare]
      var m = {};
      Q.p.variants.forEach(function (v) {
        var k = Q.kind === 'e' ? '' : Q.kind === 's' ? keyOf(v.option1) + '/' + keyOf(v.option2) : keyOf(v.option1);
        m[k] = [v.price, v.available, v.id, v.compare_at_price || 0];
      });
      return m;
    }
    function ok(m, k) { return !!(m[k] && m[k][1]); }
    function preselect(m) {
      var keys = Object.keys(m), av = keys.filter(function (k) { return m[k][1]; });
      if (Q.kind === 'e') return {};
      // 手鍊尺寸跟商品頁一樣不幫客人先選（量手腕再選；卡在中間選大的）；項鍊長度先選最多人選的 20"
      if (Q.kind === 's') {
        var ns = av.map(function (k) { return k.split('/')[0]; });
        return { n: ns.indexOf('20') >= 0 ? '20' : ns[0] || '', b: '' };
      }
      if (Q.kind === 'b') return { x: '' };
      return { x: av.indexOf('20') >= 0 ? '20' : av[0] || '' };
    }
    function dimsOf(m) {
      var ns = [], bs = [];
      Q.p.variants.forEach(function (v) {
        var a = keyOf(v.option1), b = keyOf(v.option2);
        if (a && ns.indexOf(a) < 0) ns.push(a);
        if (Q.kind === 's' && b && bs.indexOf(b) < 0) bs.push(b);
      });
      if (Q.kind === 'e') return [];
      if (Q.kind === 's') return [{ key: 'n', label: 'ネックレスの長さ', opts: ns }, { key: 'b', label: 'ブレスレットのサイズ', opts: bs }];
      return [{ key: 'x', label: Q.kind === 'b' ? 'サイズ' : '長さ', opts: ns }];
    }

    function render() {
      var m = combos(), sel = Q.sel, dims = dimsOf(m), sold = !Q.p.available && !Q.opt.pick;
      var key = Q.kind === 'e' ? '' : Q.kind === 's' ? sel.n + '/' + sel.b : sel.x, good = Q.opt.pick ? !!(pickOf(key) && pickOf(key).ok) : ok(m, key);
      var html = '';
      dims.forEach(function (dm) {
        html += '<div class="icm-q__label">' + dm.label + (Q.opt.pick ? '（セット価格）' : '') + '</div><div class="icm-q__opts" style="--n:' + Math.max(dm.opts.length, 2) + '">';
        dm.opts.forEach(function (k) {
          var avail, sub;
          if (Q.kind === 's') {
            avail = dm.key === 'n' ? dims[1].opts.some(function (b) { return ok(m, k + '/' + b); }) : ok(m, sel.n + '/' + k);
            sub = !avail ? '売り切れ' : esc(k) + '"';
          } else if (Q.opt.pick) { var pi = pickOf(k); avail = !!(pi && pi.ok); sub = avail ? money(pi.p) : '売り切れ'; }
          else { avail = ok(m, k); sub = avail ? money(m[k][0] - discOf(m, k)) : '売り切れ'; }
          var on = sel[dm.key] === k, hot = Q.kind === 'n' && k === '20' && avail;
          html += '<button type="button" class="icm-q__opt' + (avail ? '' : ' is-sold') + '" data-dim="' + dm.key + '" data-k="' + esc(k) + '" aria-pressed="' + on + '"' + (avail ? '' : ' disabled') +
            ' aria-label="' + esc(cmLab(k)) + (avail ? '' : '、' + sub) + '"><span class="icm-q__optk">' + esc(cmLab(k)) + '</span><span class="icm-q__opts2">' + sub + '</span>' + (hot ? '<span class="icm-q__flag">定番</span>' : '') + '</button>';
        });
        html += '</div>';
      });
      $(wrap, '[data-q-dims]').innerHTML = html;
      $$(wrap, '.icm-q__opt').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.dataset.dim, k = b.dataset.k;
          if (Q.kind === 's' && d === 'n') {
            Q.sel.n = k; if (Q.sel.b && !ok(m, k + '/' + Q.sel.b)) Q.sel.b = '';
          } else Q.sel[d] = k;
          render();
        });
      });
      $(wrap, '[data-q-pairnote]').hidden = Q.kind !== 'e';
      // 看戴起來落在哪／尺寸怎麼選
      var g = $(wrap, '[data-q-guide]'), hasGuide = Q.kind === 'n' || Q.kind === 's' || Q.kind === 'b';
      g.hidden = !hasGuide; g.setAttribute('aria-expanded', Q.guide ? 'true' : 'false');
      $(wrap, '[data-q-guide-label]').textContent = Q.kind === 'b' ? 'サイズの選び方' : 'つけた時の位置を見る';
      var selLen = Q.kind === 'n' ? sel.x : Q.kind === 's' ? sel.n : '';
      var tryBox = $(wrap, '[data-q-try]');
      tryBox.hidden = !(Q.guide && (Q.kind === 'n' || Q.kind === 's') && LEN[selLen]);
      if (!tryBox.hidden) {
        var ti = $(wrap, '[data-q-tryimg]'); if (Q.tryImg && ti.getAttribute('src') !== Q.tryImg) ti.src = Q.tryImg;
        var lens = dims.length ? dims[0].opts : [];
        $$(wrap, '[data-qline]').forEach(function (p) { var k = p.dataset.qline; p.classList.toggle('is-off', lens.indexOf(k) < 0); p.classList.toggle('is-on', k === selLen); });
        $(wrap, '[data-q-trytitle]').textContent = LEN[selLen].t; $(wrap, '[data-q-trydesc]').textContent = LEN[selLen].d;
      }
      var sizeBox = $(wrap, '[data-q-size]');
      sizeBox.hidden = !(Q.guide && Q.kind === 'b');
      if (!sizeBox.hidden) {
        var opts = dims[0].opts;
        $(wrap, '[data-q-sizerows]').innerHTML = opts.map(function (k) {
          return '<div class="icm-q__sizerow' + (k === sel.x ? ' is-on' : '') + '"><span>' + (IN[k] || '') + 'cm（' + esc(k) + '"）</span><span>' + (FIT[k] || '') + '</span></div>';
        }).join('');
        $(wrap, '[data-q-sizenote]').textContent = opts.indexOf('7') >= 0 && opts.indexOf('8') >= 0 ? '手首のいちばん細いところをひと回り測ってください。目安の範囲に入るサイズを、2サイズの間なら大きい方をお選びください：手首まわり17cm以下は17.8cm、17cmを超える場合は20.3cm。' : '手首のいちばん細いところをひと回り測り、上の表と照らし合わせてお選びください。';
      }
      // 加入購物車
      var cta = $(wrap, '[data-q-add]'), note = $(wrap, '[data-q-note]');
      if (Q.opt.pick) {                                   // 組合卡開的：按了把車裡那條換成組合
        var pk = good ? pickOf(key) : null;
        cta.textContent = good ? cmLab(key) + 'でセットにする・' + money(pk.p) : key ? 'このサイズはセットで売り切れです' : (Q.kind === 'b' ? 'サイズ' : '長さ') + 'を選んでください';
        note.textContent = good ? 'カートの' + (Q.kind === 'b' ? 'ネックレス' : 'ブレスレット') + 'とセットに変更' + (pk.sep > pk.p ? '・単品合計より' + money(pk.sep - pk.p) + 'お得' : '') : '選ぶとセットに変更できます';
        return;
      }
      var price = good ? m[key][0] : 0, dsc = good ? discOf(m, key) : 0;
      cta.innerHTML = sold ? '再入荷のお知らせ（商品ページへ）' : good ? 'カートに入れる・' + (dsc ? '<s>' + money(price) + '</s> ' + money(price - dsc) : money(price)) : (Q.kind === 'b' ? 'サイズ' : Q.kind === 's' && sel.n && !sel.b ? 'ブレスレットのサイズ' : '長さ') + 'を選んでください';
      var save = good && m[key][3] > price ? m[key][3] - price : 0;
      note.textContent = (sold ? 'このアイテムは現在すべて売り切れです' : !good ? '選ぶとカートに追加できます' : Q.kind === 'e' ? '1ペア（両耳）・' + Q.info.color
        : Q.kind === 's' ? 'ネックレス ' + cmLab(sel.n) + '・ブレスレット ' + cmLab(sel.b) + (save ? '・単品合計より' + money(save) + 'お得' : '') : cmLab(sel.x) + '（' + sel.x + '"）・' + Q.info.color)
        + (dsc ? '・2点目 ' + money(dsc) + ' OFF（自動適用）' : '');
    }

    $(wrap, '[data-q-guide]').addEventListener('click', function () {
      Q.guide = !Q.guide;
      if (Q.guide && Q.kind === 's' && !Q.tryImg) {
        var nh = Q.p.handle.replace('-set-', '-').replace('-chain-', '-necklace-');
        getProduct(nh).then(function (np) { Q.tryImg = img(np.featured_image, 450); render(); }).catch(function () {});
      }
      render();
    });

    $(wrap, '[data-q-add]').addEventListener('click', function () {
      if (!Q.p) return;
      if (Q.opt.pick) {
        var pk = pickOf(Q.sel.x);
        if (!pk || !pk.ok) return;
        var go = Q.opt.pick.go, k = Q.sel.x;
        close(); go(k); return;
      }
      if (!Q.p.available) { window.location.href = (Q.p.url || '/products/' + Q.p.handle) + '#icm-restock'; return; }   // 售完：到商品頁填 Email
      var m = combos(), sel = Q.sel, key = Q.kind === 'e' ? '' : Q.kind === 's' ? sel.n + '/' + sel.b : sel.x;
      if (!ok(m, key)) return;
      var btn = this; btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: m[key][2], quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { toast(res.j.description || 'カートに追加できませんでした。もう一度お試しください', false); return; }
          close();
          var what = (Q.kind === 'n' || Q.kind === 'b' ? cmLab(sel.x) + ' ' : '') + Q.info.series + ' ' + Q.info.name;
          if (!(window.icmDrawer && window.icmDrawer.on)) toast('カートに追加しました：' + what, true);   // 有側滑就由側滑當提示
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.setAttribute('data-header-cart-count', cart.item_count); el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('icm:cart:updated', { detail: cart }));
          });
        }).catch(function () { btn.disabled = false; toast('通信が混み合っています。もう一度お試しください', false); });
    });

    return {
      open: function (handle, info, opener, opt) {
        lastFocus = opener || null;
        getProduct(handle).then(function (p) {
          Q.p = p; Q.info = info; Q.opt = opt || {}; Q.guide = !!Q.opt.guide;
          Q.kind = info.kind || (p.type === 'Bracelets' ? 'b' : p.type === 'Earrings' ? 'e' : (p.tags || []).indexOf('組合') >= 0 ? 's' : 'n');
          Q.tryImg = Q.kind === 'n' ? img(p.featured_image, 450) : '';
          Q.sel = preselect(combos());
          if (Q.opt.pick && Q.opt.pick.sel && (Q.kind === 'b' || Q.kind === 'n')) Q.sel = { x: Q.opt.pick.sel };
          if (Q.opt.vid && (Q.kind === 'b' || Q.kind === 'n')) {
            var cm = combos(); for (var ck in cm) if (String(cm[ck][2]) === String(Q.opt.vid) && cm[ck][1]) Q.sel = { x: ck };
          }
          var im = $(wrap, '[data-q-img]'); im.src = img(info.img || p.featured_image, 160); im.alt = '';
          var pics = $(wrap, '[data-q-pics]'), ims = Q.opt.photos ? (p.images || []).slice(0, 8) : [];
          if (pics) {
            pics.innerHTML = ims.map(function (u, i) {
              return '<img src="' + img(u, 600) + '" alt="' + esc((info.series + ' ' + info.name).trim()) + '（' + (i + 1) + '/' + ims.length + '）" width="600" height="750"' + (i > 1 ? ' loading="lazy"' : '') + '>';
            }).join('');
            pics.hidden = !ims.length; pics.scrollLeft = 0;
          }
          wrap.classList.toggle('is-detail', !!ims.length);
          var bd = $(wrap, '.icm-q__body'); if (bd) bd.scrollTop = 0;
          $(wrap, '[data-q-series]').textContent = info.series; $(wrap, '[data-q-name]').textContent = info.name; $(wrap, '[data-q-color]').textContent = info.color;
          $(wrap, '[data-q-page]').href = p.url || '/products/' + handle;
          render();
          wrap.hidden = false; document.documentElement.classList.add('icm-lock');
          var x = $(wrap, '.icm-x'); if (x) x.focus();
        }).catch(function () { toast('通信が混み合っています。もう一度お試しください', false); });
      }
    };
  }

  function infoOf(card) {
    var im = card.querySelector('img');
    return { kind: card.dataset.kind, series: card.dataset.series, name: card.dataset.name, color: card.dataset.color, img: im ? im.currentSrc || im.src : '' };
  }

  // ---------- 系列頁
  function Coll(root) {
    var cat = root.dataset.cat, grid = $(root, '[data-icm-grid]');
    var cards = $$(grid, '[data-pc]');
    var stack = $(root, '[data-stack]'), setban = $(root, '[data-setban]');
    var quick = Quick(root);
    var hasWidths = cat === 'n' || cat === 'b' || cat === 's';
    var styles = STY[cat === 'mix' ? 'mix' : cat].filter(function (s) {
      return s[0] === 'all' || cards.some(function (c) { return (cat === 'mix' ? c.dataset.kind : c.dataset.st) === s[0]; });
    });
    var st = { color: 'all', style: 'all', width: 'all', stock: false, sort: 'rec', more: false };
    var q = new URLSearchParams(location.search);
    // 網址的 ?style=；搜尋頁搜種類名稱（ピアス…）時由 data-style0 先篩好
    var s0 = q.get('style') || root.dataset.style0;
    if (s0 && styles.some(function (s) { return s[0] === s0; })) st.style = s0;
    if (q.get('width') && hasWidths && WIDTHS.some(function (w) { return w[0] === q.get('width'); })) st.width = q.get('width');
    if (q.get('color') && (q.get('color') === 'w' || q.get('color') === 'g')) st.color = q.get('color');

    function set(o) { for (var k in o) st[k] = o[k]; if (!('more' in o)) st.more = false; render(); }
    function pillsHtml(list, cur, cls, attr) {
      return list.map(function (x) { return '<button type="button" class="' + cls + (x[0] === cur ? ' is-on' : '') + '" ' + attr + '="' + x[0] + '" aria-pressed="' + (x[0] === cur) + '">' + x[1] + (x[2] !== undefined && cls.indexOf('wd') >= 0 ? '<small>' + x[2] + '</small>' : '') + '</button>'; }).join('');
    }

    function drawControls() {
      $$(root, '[data-colors]').forEach(function (box) {
        box.innerHTML = COLORS.map(function (c) {
          var on = st.color === c[0];
          return '<button type="button" class="icm-cbtn' + (on ? ' is-on' : '') + '" data-color="' + c[0] + '" aria-pressed="' + on + '">' + (c[2] ? '<i style="background:' + c[2] + '"></i>' : '') + c[1] + '</button>';
        }).join('');
      });
      $$(root, '[data-styles]').forEach(function (box) {
        var side = box.classList.contains('icm-side__styles');
        box.innerHTML = styles.map(function (s) { var on = st.style === s[0]; return '<button type="button" class="' + (side ? 'icm-side__style' : 'icm-spill') + (on ? ' is-on' : '') + '" data-sty="' + s[0] + '" aria-pressed="' + on + '">' + s[1] + '</button>'; }).join('');
      });
      $$(root, '[data-widths]').forEach(function (box) { box.innerHTML = pillsHtml(WIDTHS, st.width, 'icm-wd', 'data-width'); });
      $$(root, '[data-widths-wrap]').forEach(function (w) { w.hidden = !hasWidths; });
      $$(root, '[data-sorts]').forEach(function (box) { box.innerHTML = pillsHtml(SORTS, st.sort, 'icm-sortb', 'data-sort'); });
      $$(root, '[data-stock]').forEach(function (i) { i.checked = st.stock; });
      var nf = (hasWidths && st.width !== 'all' ? 1 : 0) + (st.stock ? 1 : 0) + (st.sort !== 'rec' ? 1 : 0);
      var fl = $(root, '[data-filter-label]'); if (fl) fl.textContent = nf ? '絞り込み（' + nf + '）' : '絞り込み';
      var fb = $(root, '[data-open-filter]'); if (fb) fb.setAttribute('aria-label', '絞り込み・並び替え' + (nf ? '（' + nf + '件適用中）' : ''));
    }

    function render() {
      var list = cards.filter(function (c) {
        var d = c.dataset;
        return (st.color === 'all' || d.c === st.color) && (st.style === 'all' || (cat === 'mix' ? d.kind : d.st) === st.style)
          && (!hasWidths || st.width === 'all' || wcat(+d.w) === st.width) && (!st.stock || d.sold === '0');
      });
      list.sort(function (a, b) {
        var s = (+a.dataset.sold) - (+b.dataset.sold); if (s) return s;
        if (st.sort === 'asc') return (+a.dataset.min) - (+b.dataset.min) || (+a.dataset.i) - (+b.dataset.i);
        if (st.sort === 'desc') return (+b.dataset.min) - (+a.dataset.min) || (+a.dataset.i) - (+b.dataset.i);
        return (+a.dataset.i) - (+b.dataset.i);
      });
      var isD = desk.matches, first = +(isD ? root.dataset.firstD : root.dataset.first) || 10;
      var shown = st.more ? list.length : Math.min(first, list.length);
      cards.forEach(function (c) { c.hidden = true; });
      if (stack) stack.hidden = true;
      if (setban) setban.hidden = true;
      var frag = document.createDocumentFragment();
      var setAfter = setban ? +setban.dataset.after : 0;
      if (isD && setAfter) setAfter = Math.ceil(setAfter / 4) * 4;
      list.forEach(function (c, i) {
        frag.appendChild(c);
        if (i < shown) c.hidden = false;
        if (stack && i === 3 && i < shown && st.width === 'all' && (st.style === 'all' || st.style === 'plain' || st.style === 'rope')) {
          var pc = st.color === 'w' ? 'w' : 'g', pair = $(stack, '[data-stack-c="' + pc + '"]');
          if (pair) { $$(stack, '[data-stack-c]').forEach(function (x) { x.hidden = x !== pair; }); stack.hidden = false; frag.appendChild(stack); }
        }
        if (setban && i === setAfter - 1 && i < shown) { setban.hidden = false; frag.appendChild(setban); }
      });
      // 其他不在清單的卡片放後面（隱藏）
      cards.forEach(function (c) { if (list.indexOf(c) < 0) frag.appendChild(c); });
      grid.appendChild(frag);
      if (stack && stack.hidden) grid.appendChild(stack);
      if (setban && setban.hidden) grid.appendChild(setban);

      $(root, '[data-empty]').hidden = list.length > 0;
      var total = cards.length;
      // 搜尋頁（data-count-mode=plain）只寫目前幾點，不寫「13 / 79点」
      $$(root, '[data-count]').forEach(function (e) { e.textContent = list.length === total || root.dataset.countMode === 'plain' ? list.length + '点' : list.length + ' / ' + total + '点'; });
      var mw = $(root, '[data-more-wrap]');
      mw.hidden = !(list.length > shown);
      if (!mw.hidden) {
        $(root, '[data-seen]').textContent = list.length + '点中 ' + shown + '点を表示';
        $(root, '[data-prog]').style.width = Math.round(shown / Math.max(list.length, 1) * 100) + '%';
      }
      $$(root, '[data-show-count]').forEach(function (b) { b.textContent = list.length + '点を表示'; });
      drawControls();
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a'); if (!t || !root.contains(t)) return;
      if (t.dataset.color) set({ color: t.dataset.color });
      else if (t.dataset.sty) set({ style: t.dataset.sty });
      else if (t.dataset.width) set({ width: t.dataset.width });
      else if (t.dataset.sort) set({ sort: t.dataset.sort });
      else if (t.hasAttribute('data-clear')) { set({ color: 'all', style: 'all', width: 'all', stock: false, sort: 'rec' }); var fs = $(root, '[data-fsheet]'); if (fs) { fs.hidden = true; document.documentElement.classList.remove('icm-lock'); } }
      else if (t.hasAttribute('data-more')) { st.more = true; render(); }
      else if (t.hasAttribute('data-open-filter')) { $(root, '[data-fsheet]').hidden = false; document.documentElement.classList.add('icm-lock'); }
      else if (t.hasAttribute('data-close-filter')) { $(root, '[data-fsheet]').hidden = true; document.documentElement.classList.remove('icm-lock'); }
      else if (t.hasAttribute('data-quick') && quick) { e.preventDefault(); var card = t.closest('[data-pc]'); quick.open(card.dataset.handle, infoOf(card), t); }
      else if (t.dataset.quickHandle && quick) {
        var c2 = cards.filter(function (c) { return c.dataset.handle === t.dataset.quickHandle; })[0];
        if (c2) quick.open(c2.dataset.handle, infoOf(c2), t);
      }
    });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-stock]')) set({ stock: e.target.checked }); });
    document.addEventListener('keydown', function (e) { var fs = $(root, '[data-fsheet]'); if (e.key === 'Escape' && fs && !fs.hidden) { fs.hidden = true; document.documentElement.classList.remove('icm-lock'); } });
    if (desk.addEventListener) desk.addEventListener('change', render); else if (desk.addListener) desk.addListener(render);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-icm-coll]').forEach(function (r) { if (!r.__icm) { r.__icm = 1; Coll(r); } });
  }
  window.IcmQuick = Quick;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
